import { useEffect, useState } from "react";
import { api } from "@/lib/api";

let cache = null;
let pending = null;
const subs = new Set();

export const setStories = (s) => { cache = s || {}; subs.forEach((f) => f(cache)); };
const load = () => {
  if (!pending) pending = api.get("/gallery/stories").then(({ data }) => setStories(data.stories)).catch(() => setStories({}));
  return pending;
};

// Jason's stories behind each gallery photo, keyed by photo src.
export const useGalleryStories = () => {
  const [stories, set] = useState(cache || {});
  useEffect(() => { subs.add(set); if (!cache) load(); return () => subs.delete(set); }, []);
  return stories;
};
